import { render } from "./BookShelf.vue?vue&type=template&id=11ae5e98&scoped=true"
import script from "./BookShelf.vue?vue&type=script&lang=js"
export * from "./BookShelf.vue?vue&type=script&lang=js"

import "./BookShelf.vue?vue&type=style&index=0&id=11ae5e98&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11ae5e98"]])

export default __exports__